// src/components/SMAConnector.js
import React from 'react';
import enirisLogo from '../img/logo.png'; // Adjust the path as necessary

const client_id = "eniris_api";
const redirect_uri = "https://thirdparty-oauth.eniris.be/sma-callback";

const SMAConnector = () => {
    const redirectToSMA = () => {
        const state = Math.random().toString(36).substring(7);
        localStorage.setItem('oauth_state', state);

        const authUrl = `https://sandbox-auth.smaapis.de/oauth2/auth?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}&state=${state}`;
        window.location.href = authUrl;
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full text-center">
                <img
                    src={enirisLogo}
                    alt="Eniris Logo"
                    className="mx-auto h-12 mb-6"
                />
                <h1 className="text-2xl font-bold mb-4 text-gray-800">Connect with SMA</h1>
                <p className="text-gray-600 mb-6">
                    Click the button below to securely link your SMA account to Eniris.
                </p>
                <button
                    onClick={redirectToSMA}
                    className="w-full bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                >
                    Connect SMA Account
                </button>
            </div>
        </div>
    );
};

export default SMAConnector;